module.exports = __webpack_public_path__ + "img/gaucha.7254ede0.png";